import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom"; 
import { loginUrl } from "./helper";
import { useDispatch } from "react-redux";
import { employeeIdBytoken, loginUserApi } from "../Redux/Services";

const HandleToken = () => {
  const navigate = useNavigate();
  const location = useLocation(); 

  useEffect(() => {
    const handleLoginFlow = async () => {
      const params = new URLSearchParams(location.hash.substring(1));
      const accessToken = params.get("access_token");
      const state = params.get("state");

      if (accessToken) {
        localStorage.setItem("access_token", accessToken);
        await loginUserApi(accessToken);
        await employeeIdBytoken();

        let returnTo = "/"; 
        if (state) {
          try {
            const decodedState = JSON.parse(atob(state));
            if (decodedState.returnTo) {
                returnTo = decodeURIComponent(decodedState.returnTo);
            }
          } catch (e) {
            console.error("Could not parse state from URL", e);
          }
        }
        navigate(returnTo, { replace: true });
      } else if (!localStorage.getItem("access_token")) {

        const queryParams = new URLSearchParams(location.search);
        const returnTo = queryParams.get("returnTo");

        const stateToPass = btoa(JSON.stringify({ returnTo: returnTo || "/" }));

        localStorage.clear();
        window.location.href = loginUrl(stateToPass);
      } else {
        navigate("/");
      }
    };

    handleLoginFlow();
  }, [navigate, location]); 

  return <div></div>; 
};

export default HandleToken;